import React from 'react';
import PropTypes from 'prop-types';
import {getPubAds} from 'src/utils/adverts';
import {isNice} from 'config/config';
import {isUserBot} from 'src/utils/seo';

const ADVERTS = {
  advert__modal__1: {
    slot: '/12650263/hucustom1',
    dimensions: [1, 1],
    id: 'div-gpt-ad-1426247584454-0',
  },
  advert__modal__2: {
    slot: '/12650263/hucustom2',
    dimensions: [1, 1],
    id: 'div-gpt-ad-1426247584454-1',
  },
};

export default class AdvertModal extends React.Component {

  static propTypes = {
    name: PropTypes.oneOf(Object.keys(ADVERTS)).isRequired,
  }

  componentDidMount() {
    this.updateAd();
  }

  updateAd = async () => {
    if (isNice || isUserBot || typeof googletag === 'undefined') return;

    await getPubAds();
    const { name } = this.props;
    const { slot, dimensions, id } = ADVERTS[name];

    googletag.cmd.push(() => {
      const service = googletag.pubads();
      const ad = googletag.defineSlot(slot, dimensions, id);
      if (ad) {
        ad.addService(service);
        googletag.display(id);
        setTimeout(() => {
          if (!!service && !!service.refresh) {
            service.refresh([ad]);
          }
        }, 1000);
      }
    });
  }

  render() {
    const { name } = this.props;
    return <div className={name} id={ADVERTS[name].id}/>;
  }
}



// WEBPACK FOOTER //
// ./src/modules/shared/modal/components/advertModal.js